import React, { useState, useEffect, memo, useMemo, useRef } from 'react';
import Header from '../../layout/Header';
import Paginated from './Paginated';
import { Link, useLocation } from 'react-router-dom';
import { importIcon } from '../../../Image/Index';
import { connect } from 'react-redux';
import { getCustomer, clearCustomer } from '../../../actions/customer';
import { decrypt, encryptionByAES } from '../../../utils/encodingdecoding';
import { Modal, Button, Form, Row, Col, Alert } from 'react-bootstrap';
import ClipLoader from 'react-spinners/ClipLoader';
import {
	getSchemaList,
	SendGridEmail,
	updateCustomer,
	updateCustomers,
} from '../../../services/auth';
import swal from 'sweetalert';
import { edsringMerchantId, rearrangeAgentFields, starblazeMerchantId } from '../../../utils';
import CustomerAddEditModal from './CustomerAddEditModal';
import { getDisplayDate } from '../../../utils/helper';
import {
	getEmailTemplateSetting,
	customerRegistrations,
	getCustomerPortalSetting,
} from '../../../services/services';

const CustomersList = memo(({ getCustomer, Customer, clearCustomer }) => {
	const location = useLocation();
	const [data, setData] = useState([]);
	const [customerCount, setCustomerCount] = useState();
	const [formData, setFormData] = useState({});
	const [response, setResponse] = useState([]);
	const [totalCustomer, setTotalCustomer] = useState(0);
	const [testAccCusCount, setTestAccCustCount] = useState(0);
	const [apiError, setApiError] = useState(null);
	const [shemaData, setSchemaData] = useState();
	const [schema, setSchema] = useState({});
	const [errors, setErrors] = useState({});
	const [selectedCustomer, setSelectedCustomer] = useState(null);
	const [loading, setLoading] = useState(false);
	const [loader, setLoader] = useState(true);
	let id = decrypt(localStorage.getItem('Id'));
	const [showModal, setShowModal] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [customerStatus, setCustomerStatus] = useState('');
	const [emailConfig, setEmailConfig] = useState({
		emailOnCustomerRegstration: {
			status: false,
			emailTempalteId: '',
		},
	});

	const [dateRange, setDateRange] = useState('');
	const [testAccounts, setTestAccounts] = useState(false);

	const disposableDomains = [
		'mailinator.com',
		'tempmail.com',
		'10minutemail.com',
		'guerrillamail.com',
		'dispostable.com',
		'mail.com',
	];

	const handleEditCustomerClick = async (customer) => {
		setShowModal(true);
		setIsEditMode(true);
		setSelectedCustomer(customer);
		setLoading(true);
		setApiError(null);
		setCustomerStatus(customer?.status || 0);

		try {
			const token = JSON.parse(localStorage.getItem('token_gen'));
			const tedata = await getSchemaList(token?.access_token);
			const schemaProps = tedata?.schema?.properties || {};
			const updatedSchema = { ...schemaProps };
			Object.keys(updatedSchema).forEach((key) => {
				if (key === 'agentFirstName' || key === 'agentLastName') {
					updatedSchema[key] = {
						...updatedSchema[key],
						minLength: 2,
						maxLength: 50,
					};
				}
			});
			setSchema(updatedSchema);

			const prefilledData = {};
			Object.keys(schemaProps)?.forEach((key) => {
				if (schemaProps[key].isFormView) {
					let value = customer[key] ?? '';
					prefilledData[key] = value;
				}
				if (customer?.status) {
					prefilledData['status'] = customer?.status;
				}
			});
			setFormData(prefilledData);
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	// useEffect(() => {
	// 	let tempPageIndex = JSON.parse(localStorage.getItem('CusPageIndex'));
	// 	if (tempPageIndex === 1) {
	// 		fetch();
	// 	}
	// 	// eslint-disable-next-line
	// }, []);

	useEffect(() => {
		setResponse(Customer?.data);
	}, [Customer]);

	const updateData = () => {
		setLoader(true);

		const token = JSON.parse(localStorage.getItem('token_gen'));

		getSchemaList(token?.access_token).then((res) => {

			const schemaProperties = { ...res?.schema?.properties };

			delete schemaProperties?.profileimageurl;

			setSchemaData(schemaProperties);
		});
	};

	useEffect(() => {
		updateData();
	}, []);

	useEffect(() => {
		const temp = response?.data?.data;
		response?.data?.testCount &&
			setTestAccCustCount(response?.data?.testCount || 0);
		response?.data?.totalCount &&
			setTotalCustomer(response?.data?.totalCount || 0);
		if (!temp) {
			setData([]);
			return;
		}
		if (temp) {
			temp?.map((val) => {
				// val.name = val.customerData.name;
				// val.membership = val.customerData.membership?.membershipType;
				// val.expiredValue = val.walletData.wallet.expiredValue;
				// val.customerid = val.customerData.customerid;
				// val.email = val.customerData.email;
				// val.mobile = val.customerData.mobile;
				id !== edsringMerchantId &&
					(val.earnedValue = val?.walletData?.wallet?.earnedValue);
				val.availableValue = val?.walletData?.wallet?.availableValue;
				val.redeemValue = val?.walletData?.wallet?.redeemValue;
				{
					id === edsringMerchantId &&
						(val.status = (
							<div
								className={
									val?.customerData?.status !== 2
										? 'status-active'
										: 'status-inactive'
								}>
								{val?.customerData?.status !== 2
									? 'Active'
									: 'Inactive'}
							</div>
						));
				}
				id === edsringMerchantId &&
					(val.customercode = (
						<Link
							to={`/customer-view/${val?.customerData?.customercode}`}
							state={{
								customerCode: val?.customerData?.customercode,
							}}
							className='edit_btn'
							csvalue='View Details'>
							{`${val?.customerData?.customercode}`}
						</Link>
					));
				id !== edsringMerchantId &&
					(val.action = (
						<>
							<Link
								to={`/customer-view/${val?.customerData?.customercode}`}
								state={{
									customerCode: val?.customerData?.customercode,
								}}
								className='edit_btn'
								csvalue='View Details'>
								<i className='fa-solid fa-eye'></i>
								<div className='show_div'>View Details</div>
							</Link>
							<CustomerAddEditModal
								isEdit={true}
								isEditToolTip={true}
								customerData={val?.customerData}
								testAccounts={testAccounts}
							/>
							{/* <Link
							to=''
							onClick={() =>
								handleEditCustomerClick(val.customerData)
							}
							className='edit_btn'
							csvalue='Edit'>
							<i className='fa-solid fa-pen'></i>
							<div className='show_div'>Edit</div>
						</Link> */}
						</>
					));
				if (shemaData) {
					Object.keys(shemaData)?.forEach((key) => {

						if (key === "profileimageurl") {
							delete val[key];
							return;
						}

						if (shemaData[key]?.isFormView) {
							let value = val.customerData[key];
							if (key === "createdAt" && value) {
								value = getDisplayDate(value)
							}

							if (value === true) {
								value = "Yes";
							} else if (value === false) {
								value = "No";
							}

							val[key] = value ?? "";
						}
					});
				}

				return val;
			});
			setData(temp);
		}
	}, [response, shemaData]);

	const [search, setSearch] = useState('');
	const debounceRef = useRef(null);
	const abortControllerRef = useRef(null);

	const fetch = async (
		testAccounts = false,
		searchText = '',
		showLoader = true,
	) => {
		// Cancel previous API call
		if (abortControllerRef.current) {
			abortControllerRef.current.abort();
		}

		const controller = new AbortController();
		abortControllerRef.current = controller;

		try {
			showLoader && setLoader(true);
			await clearCustomer();

			const token = JSON.parse(localStorage.getItem('token_gen'));
			const id = localStorage.getItem('Id');

			await getCustomer(
				token?.access_token,
				id,
				1,
				50,
				searchText,
				testAccounts,
				{ signal: controller.signal },
			);
		} catch (err) {
			if (err.name !== 'AbortError') {
				console.error('Customer fetch failed:', err);
			}
		} finally {
			showLoader && setLoader(false);
		}
	};

	const dynamicColumns = useMemo(() => {
		if (!shemaData) return [];

		return Object.entries(shemaData)
			.filter(([key, value]) => value.isFormView && key !== 'isTest')
			.map(([key, value]) => ({
				Header: value.fielddisplayname || value.label || key,
				Footer: value.fielddisplayname || value.label || key,
				accessor: key,
			}));
	}, [shemaData]);

	const columns = useMemo(() => {
		const staticColumns = [
			...dynamicColumns,
			{
				Header: 'Earned Value',
				Footer: 'Earned Value',
				accessor: 'earnedValue',
			},
			{
				Header: 'Available Value',
				Footer: 'Available Value',
				accessor: 'availableValue',
			},
			{
				Header: 'Redeem Value',
				Footer: 'Redeem Value',
				accessor: 'redeemValue',
			},
			{
				Header: 'Action',
				Footer: 'Action',
				accessor: 'action',
			},
		];
		return staticColumns;
	}, [dynamicColumns]);

	const searchableKeys = useMemo(() => {
		return columns
			.map((col) => col.accessor)
			.filter(
				(key) => key && typeof key === 'string' && key !== 'action', // ignore JSX column
			);
	}, [columns]);

	const objectContainsSearch = (row, query, keys) => {
		if (!row || !query) return true;

		const q = query.toLowerCase();

		return keys.some((key) => {
			const value = row[key];

			if (value === null || value === undefined) return false;

			if (typeof value === 'string' || typeof value === 'number') {
				return String(value).toLowerCase().includes(q);
			}

			if (Array.isArray(value)) {
				return value.some(
					(v) =>
						(typeof v === 'string' || typeof v === 'number') &&
						String(v).toLowerCase().includes(q),
				);
			}

			return false;
		});
	};

	// const fetch = async (testAccounts = false) => {
	// 	setLoader(true);
	// 	await clearCustomer();
	// 	const token = JSON.parse(localStorage.getItem('token_gen'));
	// 	let id = localStorage.getItem('Id');
	// 	await getCustomer(token?.access_token, id, 1, 50, ' ', testAccounts);
	// 	setTimeout(() => {
	// 		setLoader(false);
	// 	}, 1000);
	// };
	const isInitialRender = useRef(true);

	useEffect(() => {
		if (isInitialRender.current) {
			isInitialRender.current = false;
			return;
		}
		if (debounceRef.current) clearTimeout(debounceRef.current);
		debounceRef.current = setTimeout(() => {
			if (!search.trim()) {
				fetch(testAccounts, '', true);
				return;
			}

			const localMatches = data.filter((row) =>
				objectContainsSearch(row, search, searchableKeys),
			);
			if (localMatches.length > 0) {
				setData(localMatches);
			} else {
				fetch(testAccounts, search);
			}
		}, 500);

		return () => clearTimeout(debounceRef.current);
	}, [search, testAccounts, searchableKeys]);

	const generateCSV = () => {
		try {
			if (!data || data.length === 0) {
				alert('No customer data available to download!');
				return;
			}
			const downloadColumns = columns?.filter(
				(col) => col.accessor !== 'action',
			);
			const headers = downloadColumns.map((col) => col.Header);
			const rows = data?.map((item) => {
				return downloadColumns?.map((col) => {
					const value = item[col.accessor];
					if (value === 0) return '0';
					if (value === null || value === undefined) return '';
					return value.toString();
				});
			});
			const csvContent = [headers, ...rows]
				.map((row) => row.join(','))
				.join('\n');
			const encodedUri = encodeURI(
				'data:text/csv;charset=utf-8,' + csvContent,
			);
			const link = document.createElement('a');
			link.setAttribute('href', encodedUri);
			link.setAttribute('download', id === starblazeMerchantId ? "retailers_data.csv" : "customers_data.csv");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		} catch (error) {
			console.error('CSV Download Error:', error);
			alert('Failed to generate CSV. Please try again.');
		}
	};

	useEffect(() => {
		setCustomerCount(Customer?.data?.data?.totalCount);
	}, [Customer]);

	const handleChange = (key, value, field) => {
		if (isEditMode && field?.isPrimaryIdent) return;

		let newErrors = { ...errors };
		if (
			field.fielddatatype !== 'Boolean' &&
			field.fielddatatype !== 'Enumeration'
		) {
			if (value.startsWith(' ')) {
				newErrors[key] = 'Leading spaces are not allowed';
				setErrors(newErrors);
				setFormData((prev) => ({ ...prev, [key]: value }));
				return;
			}
			if (value.endsWith(' ')) {
				newErrors[key] = 'Trailing spaces are not allowed';
				setErrors(newErrors);
				setFormData((prev) => ({ ...prev, [key]: value }));
				return;
			}

			delete newErrors[key];
		}

		let processedValue = value;

		if (field?.fielddatatype === 'Integer' || field?.type === 'number') {
			processedValue = value ? parseInt(value, 10) : '';

			if (
				value &&
				(!Number.isInteger(Number(value)) || Number(value) < 0)
			) {
				newErrors[key] = 'Must be a valid non-negative integer';
			} else {
				delete newErrors[key];
			}
		}

		if (key === 'agentFirstName' || key === 'agentLastName') {
			const minLen = field?.minLength || null;
			const maxLen = field?.maxLength || null;
			if (value && minLen && value.length < minLen) {
				newErrors[key] = `Minimum ${minLen} characters required`;
			} else if (value && maxLen && value.length > maxLen) {
				newErrors[key] = `Maximum ${maxLen} characters allowed`;
			} else {
				delete newErrors[key];
			}
		}

		if (field?.fielddisplayname?.toLowerCase() === 'email') {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

			if (value && !emailRegex.test(value)) {
				newErrors[key] = 'Invalid email';
			} else {
				if (value) {
					const domain = value.split('@')[1]?.toLowerCase();
					if (disposableDomains.includes(domain)) {
						newErrors[key] = 'Disposable emails are not allowed';
					} else {
						delete newErrors[key];
					}
				}
			}
		}

		setErrors(newErrors);
		setFormData((prev) => ({ ...prev, [key]: processedValue }));
	};

	const handleCreateCustomerClick = async () => {
		setShowModal(true);
		setIsEditMode(false);
		setFormData({
			...(id === edsringMerchantId && {
				notificationsEnabled: true,
				monthlyPointsStatement: true,
				programUpdatesAndNews: true,
				specialOffersAndPromotion: true,
				smsnotification: true,
				transaction: true,
			}),
		});
		setErrors({});
		setLoading(true);
		setApiError(null);
		try {
			const token = JSON.parse(localStorage.getItem('token_gen'));
			const tedata = await getSchemaList(token?.access_token);
			const res = await getCustomerPortalSetting(token?.access_token);
			if (res.message === 'Settings retrieved successfully') {
				setEmailConfig((prev) => ({
					...prev,
					emailOnCustomerRegstration:
						res?.data?.emailSetting?.EmailOnCustomerRegstration,
				}));
			}
			const updatedSchema = tedata?.schema?.properties || {};
			Object?.keys(updatedSchema)?.forEach((key) => {
				if (key === 'agentFirstName' || key === 'agentLastName') {
					updatedSchema[key] = {
						...updatedSchema[key],
						minLength: 2,
						maxLength: 50,
					};
				}
			});
			setSchema(updatedSchema);
		} catch (e) {
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	const handleSubmit = async () => {
		if (Object.keys(errors).length > 0) {
			alert('Please fix validation errors before submitting.');
			return;
		}

		const emailFieldKey = Object.keys(schema)?.find(
			(key) => schema[key]?.fielddisplayname?.toLowerCase() === 'email',
		);

		// const agentIdValue = formData["agentId"]?.trim() || "";

		// if (!agentIdValue) {
		//     setErrors((prev) => ({
		//         ...prev,
		//         agentId: "Agent Id is required",
		//     }));
		//     return;
		// }

		if (formData.notificationsEnabled) {
			if (
				!formData[emailFieldKey] ||
				formData[emailFieldKey].trim() === ''
			) {
				setErrors((prev) => ({
					...prev,
					[emailFieldKey]:
						'Email is required when notifications are enabled.',
				}));
				return;
			}
		} else {
			setErrors((prev) => {
				const newErrors = { ...prev };
				delete newErrors[emailFieldKey];
				return newErrors;
			});
		}

		try {
			setLoading(true);
			setApiError(null);
			const token = JSON.parse(localStorage.getItem('token_gen'));
			const processedFormData = {};
			Object.keys(formData)?.forEach((key) => {
				const field = schema[key];
				if (isEditMode && field?.isPrimaryIdent) {
					return;
				}
				if (key === 'notificationsEnabled') return;
				processedFormData[key] = formData[key];
				if (
					(field?.fielddatatype === 'Integer' ||
						field?.type === 'number') &&
					processedFormData[key]
				) {
					processedFormData[key] = parseInt(
						processedFormData[key],
						10,
					);
				}
			});
			if (isEditMode) {
				Object.keys(processedFormData)?.forEach((key) => {
					if (key === 'status') return;
					const value = processedFormData[key];
					if (
						value === '' ||
						value === null ||
						value === undefined ||
						value === 0 ||
						(typeof value === 'object' &&
							Object.keys(value).length === 0)
					) {
						delete processedFormData[key];
					}
				});
				const res = await updateCustomer(
					token?.access_token,
					selectedCustomer?.customercode,
					processedFormData,
				);
				if (res.message === 'Request processed successfully.') {
					setShowModal(false);
					await fetch();
					swal({
						position: 'center',
						icon: 'success',
						title: `${id === starblazeMerchantId ? "Retailer" : "Customer"} details update successfully`,
						showConfirmButton: false,
						timer: 5000,
					});
				} else {
					setApiError(
						res?.errors?.[0]?.detail ||
						'An error occurred while updating the customer.',
					);
				}
			} else {
				const custRes = await customerRegistrations(
					token?.access_token,
					processedFormData,
				);
				if (custRes.message === 'Request processed successfully.') {
					const id = localStorage.getItem('Id');
					const res = await getEmailTemplateSetting(
						token?.access_token,
						id,
					);
					const template = res?.data?.EmailTemplateSetting?.filter(
						(template) =>
							template.id ===
							emailConfig?.emailOnCustomerRegstration
								?.emailTempalteId,
					);
					const tempBody = template?.[0]?.Body?.replace(
						/{{agentFirstName}}/g,
						formData.agentFirstName || 'User',
					)?.replace(
						/\[PORTAL_URL\]/g,
						'https://rewards.edsring.com.au',
					);
					if (formData?.notificationsEnabled) {
						const body = {
							subject: template?.[0]?.Subject,
							sendgridApiKey: template?.[0]?.sendgridApiKey,
							fromEmail: template?.[0]?.fromEmail,
							fromName: template?.[0]?.fromName,
							emails: [
								{
									Name:
										formData?.agentFirstName ||
										formData?.agentLastName ||
										'User',
									email: formData?.email,
									customercode: encryptionByAES(
										custRes?.data?.customercode,
									),
								},
							],
							body: tempBody,
							purpose: 'Welcome Email',
							fileName: '',
						};
						await SendGridEmail(token?.access_token, body);
					}
					setShowModal(false);
					await fetch();
					swal({
						position: 'center',
						icon: 'success',
						title: `${id === starblazeMerchantId ? "Retailer" : "Customer"}Customer registered successfully`,
						showConfirmButton: false,
						timer: 5000,
					});
				} else {
					setApiError(
						custRes.message ||
						'An error occurred.',
					);
				}
			}
		} catch (error) {
			console.error(
				isEditMode
					? 'Customer Update Error => '
					: 'Customer Create Error => ',
				error,
			);
			setApiError(
				error.response?.data?.message ||
				`An error occurred while ${isEditMode ? 'updating' : 'creating'
				} the customer.`,
			);
		} finally {
			setLoading(false);
		}
	};
	const isFormValid = () => {
		if (Object.keys(errors).length > 0) {
			return false;
		}
		return Object.keys(formData).some((key) => {
			return formData[key] !== undefined && formData[key] !== '';
		});
	};

	const formatMobileNumber = (value) => {
		if (!value) return '';

		let digits = value.replace(/\D/g, '');

		if (digits.startsWith('0')) {
			digits = digits.slice(1);
		} else if (digits.startsWith('61')) {
			digits = digits.slice(2);
		}

		let formatted = '+61 ';

		if (digits.length <= 3) {
			formatted += digits;
		} else if (digits.length <= 6) {
			formatted += `${digits.slice(0, 3)} ${digits.slice(3)}`;
		} else {
			formatted += `${digits.slice(0, 3)} ${digits.slice(
				3,
				6,
			)} ${digits.slice(6, 9)}`;
		}

		return formatted;
	};

	const handleTestAccountsToggle = async () => {
		localStorage.setItem('CusPageIndex', 1);
		setTestAccounts(!testAccounts);
	};
	useEffect(() => {
		return () => {
			setSearch('');
			if (abortControllerRef.current) {
				abortControllerRef.current.abort();
			}
		};
	}, []);
	return (
		<>
			<Header
				name={
					`${id === starblazeMerchantId ? "Retailer" : "Customer"} Management`
				}
			/>
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='dashboard__content'>
				<div className='container-fluid'>
					{id !== edsringMerchantId ? (
						<div className='dashboard__transactionsCard'>
							<div className='dashboard__header'>
								<div className='dashboard__left'>
									<h4>{id === starblazeMerchantId ? "Retailer" : "Customer"} Data</h4>
								</div>
								<div className='dashboard__right'>
									<Link
										to='/uploading-existing-datas?type=customer'
										id='upload_customer'
										state={{ from: 'customer' }}
										className='btn btn-default'>
										<img
											src={importIcon}
											alt=''
										/>{' '}
										Upload {id === starblazeMerchantId ? "Retailer" : "Customer"}
									</Link>
								</div>
							</div>
							<div className='dashboard__body'>
								<p>No existing {id === starblazeMerchantId ? "retailer" : "customer"} data. </p>
								<p>
									You can add data by uploading a CSV file
									containing the details.{' '}
								</p>
							</div>
						</div>
					) : (
						<></>
					)}
					<div className='dashboard__customersCard'>
						<div className='dashboard__header'>
							<div className='dashboard__left'>
								<h4>
									{id === starblazeMerchantId ? "Retailer" : "Customer"} List{' '}
									{id === edsringMerchantId ? (
										<>
											(<span>{totalCustomer}</span>)
										</>
									) : (
										<></>
									)}
								</h4>
							</div>

							<div className='dashboard__right'>
								{id === edsringMerchantId ? (
									<>
										<div style={{ maxWidth: '20rem' }}>
											<input
												type='text'
												value={search}
												placeholder='Search customer...'
												onChange={(e) =>
													setSearch(e.target.value)
												}
												style={{
													width: '100%',
													padding: '0.6rem',
													borderRadius: '0.4rem',
													border: '1px solid #d1d5db',
													fontSize: '0.9rem',
												}}
											/>
											{loader && (
												<p
													style={{
														marginTop: '0.4rem',
														fontSize: '0.8rem',
													}}>
													Searching…
												</p>
											)}
										</div>
										&nbsp;&nbsp;&nbsp;&nbsp;
										<Link
											to='/uploading-existing-datas?type=customer'
											id='upload_customer'
											state={{ from: 'customer' }}
											className='btn btn-default'>
											<img
												src={importIcon}
												alt=''
											/>{' '}
											Upload {id === starblazeMerchantId ? "Retailer" : "Customer"}
										</Link>
										&nbsp;&nbsp;&nbsp;&nbsp;
									</>
								) : (
									<></>
								)}
								<button
									onClick={generateCSV}
									className='btn btn-default'>
									<i
										className='fa-solid fa-download'
										style={{ marginRight: '10px' }}></i>
									Download {id === starblazeMerchantId ? "Retailer" : "Customer"}
								</button>
								<CustomerAddEditModal
									isEdit={false}
									testAccounts={testAccounts}
								/>
								{/* <button
									className='btn btn-default'
									onClick={handleCreateCustomerClick}>
									Add Customer
								</button> */}
							</div>
						</div>
						{id === edsringMerchantId ? (
							<div className='customer_list_container'>
								{/* Date Enrolled */}
								{/* <div className='customer_list_filterGroup'>
									<span className='customer_list_label'>DATE ENROLLED</span>
									<select
										value={dateRange}
										onChange={(e) =>
											setDateRange(e.target.value)
										}
										className='customer_list_select'
										>
										<option value='all'>All Time</option>
										<option value='7'>Last 7 Days</option>
										<option value='30'>Last 30 Days</option>
									</select>
								</div> */}

								{/* Test Accounts Toggle */}
								<div className='customer_list_toggleGroup'>
									<span className='customer_list_toggleLabel'>
										Test Accounts
									</span>

									<span className='customer_list_badge'>
										{testAccCusCount}
									</span>

									{/* <label className='customer_list_switch'>
										<input
											type='checkbox'
											checked={testAccounts}
											onChange={handleTestAccountsToggle}
											style={{ display: 'none' }}
										/>
										<span
											style={{
												...styles.slider,
												...(testAccounts
													? styles.sliderOn
													: {}),
											}}
										/>
									</label> */}

									<div className='customer_list_switch'>
										<label className='toggle mb-0'>
											<input
												type='checkbox'
												name='status'
												checked={testAccounts}
												onChange={
													handleTestAccountsToggle
												}
											/>

											<span className='slider' />

											<span
												className='labels'
												data-on={
													testAccounts ? 'Show' : ''
												}
												data-off={
													!testAccounts ? 'Hide' : ''
												}></span>
										</label>
									</div>
								</div>
							</div>
						) : (
							<></>
						)}
						<div className='dashboard__body'>
							<Paginated
								data={data}
								columns={columns}
								loader={loader}
								setLoader={setLoader}
								testAccounts={testAccounts}
								search={search}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
});

const mapStateToProps = (state) => ({
	Customer: state.Customer,
});
const mapDispatchToProps = {
	getCustomer,
	clearCustomer,
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersList);
